import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'date',
    standalone: false
})
export class DatePipe implements PipeTransform {
constructor(private datePipe: DatePipe) {}

  transform(value: any, format: string = 'MMM d, y'): string | null {
    if (!value) return null;
    return this.datePipe.transform(value, format);
  }

}
